import React from 'react';
import { connect } from 'react-redux';
import MenuItem from './menuItem';
import MenuTree from './menuTree';

const Menu = props => {
  const user = props.user || {};
  const userGroupId = user.grupo_idgrupo;
  const config = props.config || {};
  const usaAdaptativo = config.usa_adaptativo;

  return (
    <ul className="sidebar-menu tree" data-widget="tree">
      <MenuItem path="/" label="Dashboard" icon="tachometer-alt" />
      {/* <MenuTree label='Cadastro' icon='edit'> */}

      <MenuTree label="Cadastro" icon="edit">
        {userGroupId !== 28 && <MenuItem path="cadgrupo" label="Grupo de Usuário" icon="group" />}

        {userGroupId !== 28 && <MenuItem path="cadusuario" label="Usuário" icon="user" />}

        {userGroupId !== 28 && <MenuItem path="cadgrupofisico" label="Grupo Físico" icon="server" />}

        <MenuItem path="cadcontrolador" label="Controlador" icon="hdd" />

        {/* <MenuItem path=''
                label='Cadastro de Mapa' icon='map-marked-alt' /> */}
      </MenuTree>

      <MenuTree label="Controlador" icon="hdd">
        {/* <MenuItem path='caddetector'
                label='Cadastro de Detector' icon='video' /> */}

        {/* <MenuItem path='cadfase'
                label='Fases do Controlador' icon='traffic-light' /> */}

        <MenuItem path="cadplano" label="Planos do Controlador" icon="sitemap" />

        <MenuItem path="cadtrocaplano" label="Tabela de Troca de Plano" icon="table" />

        <MenuItem path="caddataespecial" label="Datas Especiais" icon="calendar-alt" />

        {/* {usaAdaptativo && <MenuItem path='cadadaptativo'
                label='Adaptativo Tempo Real' icon='clock' />} */}

        <MenuItem path="contagemvolumetrica" label="Contagem Volumétrica" icon="car" />

        {userGroupId !== 28 && usaAdaptativo && (
          <MenuItem path="log-adaptativo" label="Histórico Adaptativo" icon="circle" />
        )}

        <MenuItem path="execplanoforcado" label="Plano Forçado" icon="gavel" />

        <MenuItem path="concontroladorerro" label="Registro de Defeitos" icon="exclamation-triangle" />

        {/* <MenuItem path='cadintervaloplano'
                label='Intervalos Plano' icon='sitemap' /> */}
      </MenuTree>

      {config && config.modulo_pluviometrico && (
        <MenuTree label="Índice Pluviométrico" icon="tint">
          <MenuItem path="pluviometro-tempo-real" label="Tempo Real" icon="tachometer-alt" />
          <MenuItem path="pluviometro-historico" label="Histórico" icon="chart-line" />
          <MenuItem path="pluviometro-mapa" label="Mapa Pluviométrico" icon="map-marked-alt" />
        </MenuTree>
      )}

      <MenuItem path="mapadefases" label="Mapa de Fases" icon="map-marked-alt" />

      {userGroupId !== 28 && (
        <MenuItem path="concontroladorerrogeral" label="Controladores com Erro" icon="exclamation-triangle" />
      )}

      {userGroupId !== 28 && <MenuItem path="conlogusuario" label="Log de Alteração" icon="history" />}

      <MenuTree label="Câmeras" icon="camera">
        {userGroupId !== 28 && <MenuItem path="cadcamera" label="Cadastro de Câmeras" icon="edit" />}
        <MenuItem path="cameradeteccao" label="Câmera de Detecção" icon="video" />
        <MenuItem path="cameramonitoramento" label="Câmera Monitoramento" icon="video" />
      </MenuTree>

      <MenuTree label="Notificações" icon="exclamation">
        <MenuItem path="telegram" label="Telegram" icon="paper-plane" />
      </MenuTree>

      <MenuItem path="ticketsuporte" label="Tickets de Suporte" icon="ticket-alt" />

      {/* <MenuTree label="Relatórios" icon="file-text-o">
      <MenuItem path="logusuario" label="Log de Usuários" icon="circle-o" />
      {usaAdaptativo && <MenuItem path="log-adaptativo" label="Log Adaptativo" icon="circle-o" />}
      <MenuItem path="erro" label="Falhas de Comunicação" icon="circle-o" />
      <MenuItem path="erroGeral" label="Erros Gerais" icon="circle-o" />
      <MenuItem path="trocaPlano" label="Histórico de Troca de Planos" icon="circle-o" />
    </MenuTree>

    <MenuItem path="configJSON" label="Configurações" icon="cog" /> */}
      {/* <MenuItemClick /> */}

      {/* Comentar menu */}
      {/* <MenuTree label='Relatórios' icon='file-pdf'> 
            <MenuItem path='relatorio'
                label='Programações de Planos' icon='file-pdf' />
        </MenuTree> */}
    </ul>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
  config: state.auth.config,
});

export default connect(mapStateToProps)(Menu);
